import { useEffect, useState } from "react";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Stats from "@/components/sections/Stats";
import Manifesto from "@/components/sections/Manifesto";
import Industries from "@/components/sections/Industries";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

const Landing = () => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const t = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(t);
    }, []);

    return (
        <main
            data-testid="landing-root"
            className="min-h-screen bg-[#050505] text-[#f5f5f5]"
        >
            <Header time={time} />
            <Hero />
            <Marquee />
            <Services />
            <Manifesto />
            <Process />
            <Stats />
            <Industries />
            <Contact />
            <Footer />
        </main>
    );
};

export default Landing;
